import { useFlag } from '@unleash/proxy-client-react';
import { isTestOrLocalEnvironment } from 'Api/documents/documents.helpers';
import { InsuranceDetails } from 'Api/insurance';
import { FormErrorDebugger } from 'Components/FormErrorDebugger/FormErrorDebugger';
import { ScrollToFieldError } from 'Components/ScrollToFieldError';
import { UnderCancellationAlert } from 'Components/UnderCancelationAlert/UnderCancellationAlert';
import { Form, Formik } from 'formik';
import React, { PropsWithChildren } from 'react';
import { useCancelForm } from './cancelForm.hooks';
import { ContentWrapper, FormFieldsWrapper } from './cancelForm.styles';
import { CancelFormValues } from './cancelForm.types';
import { CancelFormButtons } from './components/CancelFormButtons/CancelFormButtons';
import { MoveInsuranceInfoCard } from './components/MoveInsuranceInfoCard';

interface CancelFormProps extends PropsWithChildren {
  insurance: InsuranceDetails;
  initialValues: CancelFormValues;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validationSchema: any;
  alertRef: React.RefObject<HTMLDivElement>;
}

export const CancelForm = ({
  insurance,
  initialValues,
  validationSchema,
  alertRef,
  children,
}: CancelFormProps): React.ReactElement => {
  const { handleSubmit } = useCancelForm(insurance);
  const getCancelDateFromCwpToggle = useFlag('get-detail-for-policy-frontend');

  if (insurance.cancellationDate) {
    return (
      <UnderCancellationAlert
        insurance={insurance}
        cwpDetailToggle={getCancelDateFromCwpToggle}
      />
    );
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting, setStatus }) =>
        handleSubmit(values, setSubmitting, setStatus)
      }
      validateOnBlur
    >
      <Form>
        <ContentWrapper>
          <FormFieldsWrapper>{children}</FormFieldsWrapper>
          <MoveInsuranceInfoCard />
        </ContentWrapper>
        <CancelFormButtons insurance={insurance} />
        <ScrollToFieldError alertRef={alertRef} />
        {isTestOrLocalEnvironment() && <FormErrorDebugger />}
      </Form>
    </Formik>
  );
};
